import { API } from "../network/API";
import { VALIDATION_STATE } from "../hooks/useValidation";
import { BaseValidator } from "./BaseValidator";
import { encode } from "../network/Encode";
var TinValidationResultStatus;
(function (TinValidationResultStatus) {
    TinValidationResultStatus["NO_INFORMATION"] = "NO_INFORMATION";
    TinValidationResultStatus["VALID"] = "VALID";
    TinValidationResultStatus["INVALID_SYNTAX"] = "INVALID_SYNTAX";
    TinValidationResultStatus["NO_SYNTAX_CHECKER"] = "NO_SYNTAX_CHECKER";
    TinValidationResultStatus["INVALID_PATTERN"] = "INVALID_PATTERN";
    TinValidationResultStatus["INVALID_LENGTH"] = "INVALID_LENGTH";
})(TinValidationResultStatus || (TinValidationResultStatus = {}));
export class TinServerValidator extends BaseValidator {
    constructor(error, country) {
        super(error);
        this.name = "TinServerValidator";
        this.country = country;
    }
    getId() {
        return this.getBaseId() + this.country;
    }
    validate(tin) {
        if (tin.length === 0) {
            return Promise.resolve({
                status: VALIDATION_STATE.SUCCESS,
                hideError: true,
            });
        }
        return new Promise((resolve, reject) => {
            API.get(encode `/crs/tin/validate?tin=${tin}&countryCode=${this.country}`)
                .then(({ validationResult }) => {
                if (validationResult === TinValidationResultStatus.VALID ||
                    validationResult === TinValidationResultStatus.NO_INFORMATION ||
                    validationResult === TinValidationResultStatus.NO_SYNTAX_CHECKER) {
                    resolve({ status: VALIDATION_STATE.SUCCESS });
                }
                else {
                    resolve({
                        status: VALIDATION_STATE.FAILED,
                        message: this.error,
                        hideError: tin.length < 8,
                    });
                }
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
}
